import React from 'react';
import type { TabDef } from '../../hooks/useSidebar';

interface SidebarTabItemProps {
  tab: TabDef;
  onAddTab: (tabId: string) => void;
  isCollapsed: boolean;
}

const SidebarTabItem: React.FC<SidebarTabItemProps> = ({ tab, onAddTab, isCollapsed }) => {
  const Icon = tab.icon;

  const handleDragStart = (e: React.DragEvent) => {
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('application/tab-id', tab.id);
    e.dataTransfer.setData('text/plain', tab.name);
  };

  if (isCollapsed) {
    return (
      <div className="relative group">
        <button
          onClick={() => onAddTab(tab.id)}
          draggable
          onDragStart={handleDragStart}
          className="eg-sidebar-icon-btn"
          title={tab.name}
        >
          <Icon className="w-5 h-5 text-engramiq-green flex-shrink-0" />
        </button>
        <span className="eg-sidebar-tooltip">{tab.name}</span>
      </div>
    );
  }

  return (
    <div className="relative group/container">
      <button
        onClick={() => onAddTab(tab.id)}
        draggable
        onDragStart={handleDragStart}
        className="eg-sidebar-item group cursor-move"
        title={tab.name}
      >
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4 text-engramiq-green flex-shrink-0" />
          <span className="text-sm font-medium eg-text-primary truncate">{tab.name}</span>
        </div>
      </button>
    </div>
  );
};

export default SidebarTabItem;
